import {
    donutBlue,
    donutGreen,
    donutGrey,
    donutYellow,
    failedStatusColor,
    primaryGreenColor,
    unansweredStatusColor,
} from '@/src/styles/theme/lightThemeOptions';

type DialogDetailTypeProp = {
    [key: string]: any;
};
export interface DelimiterTypeProps {
    value: string;
    label: string;
    disabled?: boolean;
    isAllFields?: boolean;
}
export const ExportFileOptions: DelimiterTypeProps[] = [
    {
        value: 'csv',
        label: 'requestAnalyticsDetails.export.fileType.csvAllFields.label',
        isAllFields: true,
    },
    {
        value: 'csv',
        label: 'requestAnalyticsDetails.export.fileType.csvVisible.label',
        isAllFields: false,
    },
];
export const ExportDelimiterOptions: DelimiterTypeProps[] = [
    {
        value: ',',
        label: 'requestAnalyticsDetails.export.delimiterType.comma.label',
        disabled: false,
    },

    {
        value: ';',
        label: 'requestAnalyticsDetails.export.delimiterType.semicolon.label',
        disabled: false,
    },
    {
        value: '|',
        label: 'requestAnalyticsDetails.export.delimiterType.verticalBar.label',
        disabled: false,
    },
    {
        value: '^',
        label: 'requestAnalyticsDetails.export.delimiterType.caret.label',
        disabled: false,
    },
];
export const CLIENT_MODIFIED_QNA_FLAG: string = 'system_metadata_qna_edited_manually';
export const DialogDetailType: DialogDetailTypeProp = {
    download_log: 'logs',
    view_questions_details: 'alllogdetails',
    view_llm_docs_details: 'llmDocumentReferences',
};
export const QuestionDetailDataLabels: DialogDetailTypeProp = {
    entity: 'requestAnalyticsDetails.QnAEntity.label',
    department: 'requestAnalyticsDetails.Department.label',
    topic: 'requestAnalyticsDetails.Topic.label',
    system_metadata_qna_edited_manually: 'requestAnalyticsDetails.ClientSpecific.label',
};
export const QuestionDetailLabels: DialogDetailTypeProp = [
    'requestAnalyticsDetails.QnAEntity.label',
    'requestAnalyticsDetails.Department.label',
    'requestAnalyticsDetails.Topic.label',
    'requestAnalyticsDetails.ClientSpecific.label',
];
export enum RoutedServiceEndpointOption {
    intent_recognizer = 'Intent_Recognizer',
    question_answering = 'QnA',
    LLM = 'LLM',
    unresolved = 'Unresolved',
    answered = 'Answered',
}
export enum RoutedServiceEndpoint {
    intent_recognizer = 'Intent recognizer',
    question_answering = 'QnA',
    LLM = 'LLM',
    unresolved = 'Unresolved',
    answered = 'Answered',
}
export const totalRequestTypes = [RoutedServiceEndpoint.answered, RoutedServiceEndpoint.unresolved];
export const totalRequestPayloadTypes = [
    RoutedServiceEndpointOption.answered,
    RoutedServiceEndpointOption.unresolved,
];
export const statusOptions = [
    { id: 1, code: 'Success', name: 'Success', color: primaryGreenColor, iconUrl: '' },
    { id: 5, code: 'Unanswered', name: 'Unanswered', color: unansweredStatusColor, iconUrl: '' },
    { id: 4, code: 'Failed', name: 'Failed', color: failedStatusColor, iconUrl: '' },
];
export const DEFAULT_ALL_RESPONSE_STATUS_OPTION = {
    id: 0,
    name: 'All',
    color: '',
    iconUrl: '',
};

export interface AnalyticsRequest {
    request: string;
    legend: string;
    addressedRequests: number;
    dislikes: number | null;
}

export const legends = [
    { request: RoutedServiceEndpointOption.intent_recognizer, legend: donutBlue },
    { request: RoutedServiceEndpointOption.question_answering, legend: donutYellow },
    { request: RoutedServiceEndpointOption.LLM, legend: donutGreen },
    { request: RoutedServiceEndpointOption.unresolved, legend: donutGrey },
];
export enum AnalyticsChartsData {
    answered_requests = 'answeredRequests',
    unresolved_requests = 'unResolvedRequests',
    total_positive_feedback = 'totalPositiveFeedback',
    total_negative_feedback = 'totalNegativeFeedback',
    feedback_skipped = 'feedbackSkipped',
    web = 'web',
    msteams = 'msteams',
    polli = 'polli',
}
export const FeedbackType = {
    like: 'like',
    dislike: 'dislike',
    skip: 'skip',
};
export const reportAnalyticsTableHeaders = [
    {
        name: 'requestAnalyticsDetails.tabel.dialogid.label',
        id: 'activityId',
        isDefault: true,
        notSHowHide: true,
        orderBy: 1,
    },
    {
        name: 'requestAnalyticsDetails.tabel.user.utterance.label',
        id: 'utterance',
        isDefault: true,
        notSHowHide: true,
        orderBy: 2,
    },
    {
        name: 'requestAnalyticsDetails.tabel.request.datetime.label',
        id: 'requestTime',
        isDefault: true,
        notSHowHide: true,
        orderBy: 3,
    },
    // {
    //     name: 'requestAnalyticsDetails.tabel.routedservice.endpoint.label',
    //     id: 'routedServiceEndpoint',
    //     notSHowHide: true,
    //     isDefault: true,
    //     orderBy: 4,
    // },
    {
        name: 'requestAnalyticsDetails.tabel.feedback.label',
        id: 'feedback',
        isDefault: true,
        notSHowHide: true,
        orderBy: 5,
    },
    {
        name: 'requestAnalyticsDetails.tabel.channel.label',
        id: 'channel',
        isDefault: false,
        orderBy: 6,
    },
    // {
    //     name: 'requestAnalyticsDetails.tabel.user.legal.entities.label',
    //     id: 'userEntity',
    //     isDefault: false,
    //     orderBy: 7,
    // },
    {
        name: 'requestAnalyticsDetails.tabel.response.datetime.label',
        id: 'responseTime',
        isDefault: false,
        orderBy: 8,
    },
    // {
    //     name: 'requestAnalyticsDetails.tabel.topintent.label',
    //     id: 'intent',
    //     isDefault: true,
    //     orderBy: 9,
    // },

    // {
    //     name: 'requestAnalyticsDetails.tabel.top.intent.confidence.percentage.label',
    //     id: 'intentScore',
    //     isDefault: true,
    //     orderBy: 10,
    // },
    // {
    //     name: 'requestAnalyticsDetails.tabel.intent.entities.label',
    //     id: 'entity',
    //     isDefault: false,
    //     orderBy: 11,
    // },
    // {
    //     name: 'requestAnalyticsDetails.tabel.questionid.label',
    //     id: 'questionId',
    //     isDefault: true,
    //     orderBy: 12,
    // },

    // {
    //     name: 'requestAnalyticsDetails.tabel.leading.question.label',
    //     id: 'question',
    //     isDefault: true,
    //     orderBy: 13,
    // },
    // {
    //     name: 'requestAnalyticsDetails.tabel.answer.confidence.percentage.label',
    //     id: 'confidenceScore',
    //     isDefault: true,
    //     orderBy: 14,
    // },
    {
        name: 'requestAnalyticsDetails.tabel.user.selection.label',
        id: 'userSelection',
        isDefault: false,
        orderBy: 15,
    },
    {
        name: 'requestAnalyticsDetails.tabel.respondedby.label',
        id: 'respondedBy',
        isDefault: true,
        notSHowHide: true,
        orderBy: 16,
    },
    {
        name: 'requestAnalyticsDetails.tabel.deepthink.label',
        id: 'deepThink',
        isDefault: true,
        notSHowHide: true,
        orderBy: 17,
    },
    {
        name: 'requestAnalyticsDetails.responseDetail.tableHeader.timeConsumed.label',
        id: 'totalTimeMs',
        isDefault: false,
        orderBy: 18,
    },
    {
        name: 'requestAnalyticsDetails.responseDetail.tableHeader.tokenUsage.label',
        id: 'totalTokenUsed',
        isDefault: false,
        orderBy: 19,
    },
];

reportAnalyticsTableHeaders.sort((a, b) => a.orderBy - b.orderBy);

reportAnalyticsTableHeaders.sort((a, b) => a.orderBy - b.orderBy);
export interface ActionType {
    value: string;
    label: string;
    icon: string;
    isEnabled: boolean;
    RequestSummary: string;
}
export const COMMON_REPORT_ACTIONS: ActionType[] = [
    {
        value: 'download_log',
        label: 'requestAnalytics.table.action.download_log',
        icon: '',
        isEnabled: true,
        RequestSummary: 'Intent recognizer',
    },
    {
        value: 'view_llm_docs_details',
        label: 'requestAnalytics.table.action.view_llm_docs_details',
        icon: '',
        isEnabled: true,
        RequestSummary: 'LLM',
    },
    {
        value: 'view_questions_details',
        label: 'requestAnalytics.table.action.viewLog.response.label',
        icon: '',
        isEnabled: true,
        RequestSummary: 'QnA',
    },
];
export const REPORT_TABLE_ACTIONS = {
    logs: 'download_log',
    questionsDetail: 'view_questions_details',
    llmDetail: 'view_llm_docs_details',
};

export const uuidRegex =
    /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

// TODO: Remove this after enabling export feature
export const IsReportExportEnabled: boolean = false;

export const ResponseDetailTableHeader: string[] = [
    'requestAnalyticsDetails.responseDetail.tableHeader.timestamp.label',
    'requestAnalyticsDetails.responseDetail.tableHeader.agent.label',
    'requestAnalyticsDetails.responseDetail.tableHeader.tools.label',
    'requestAnalyticsDetails.responseDetail.tableHeader.timeConsumed.label',
    'requestAnalyticsDetails.responseDetail.tableHeader.tokenUsage.label',
    'requestAnalyticsDetails.responseDetail.tableHeader.model.label',
    'requestAnalyticsDetails.responseDetail.tableHeader.finish.label',
    'requestAnalyticsDetails.responseDetail.tableHeader.action.label',
];
